<template>
<div>
  <bk-input-label>{{$t('STEP_ONE.AGE_OF.0')}}</bk-input-label>
  <div class="search-age">
    <bk-select
      id="from"
      :fields="ageFromField"
      :label="$t('STEP_ONE.AGE_OF.FROM')"
      :width="'129px'"
      :value="valueFrom"
      @input="inputFrom($event)"
    ></bk-select>

    <bk-select
      id="till"
      :fields="ageToField"
      :label="$t('STEP_ONE.AGE_OF.TO')"
      :width="'129px'"
      :value="valueTo"
      @input="inputTill($event)"
    ></bk-select>

  </div>
</div>
</template>

<script>
import BkSelect from '../../../common/BkSelect'
import BkInputLabel from '../../../common/BkInputLabel'

export default {
  name: 'BkAgeSelect',
  components: { BkSelect, BkInputLabel },
  props: {
    min: Number,
    max: Number,
    minRange: Number,
    value: [Number, Array],
  },
  computed: {
    ageFromField () {
      return Array.apply(null, { length: this.max - this.min - this.minRange + 1 }).map((_, index) => index + this.min)
    },
    ageToField () {
      return Array.apply(null, { length: this.max - this.min - this.minRange + 1 }).map((_, index) => index + this.min + this.minRange )
    },
    valueFrom () {
      return this.value[0]
    },
    valueTo () {
      return this.value[1]
    }
  },
  methods: {
    inputFrom (event) {
      const from = parseInt(event);
      if (this.valueTo - from < this.minRange) {
        this.change(from, from + this.minRange)
      } else {
        this.change(from, this.valueTo)
      }
    },
    inputTill (event) {
      const to = parseInt(event);
      if(to - this.valueFrom < this.minRange) {
        this.change(to - this.minRange, to)
      } else {
        this.change(this.valueFrom, to)
      }
    },
    change (from, to) {
      this.$emit('change', [from, to])
    }

  }
}
</script>

<style scoped lang="scss">
  .search-age {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }
</style>